import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {AppRoles} from '../../../app.constants';
import {
    MeasuringPointService,
    SearchMeasuringPointDto,
    SearchMeasuringPointResultDto,
    ServiceDto,
    ServiceService,
    ServiceType
} from '../../../_services/configuration-services';
import {MsalService} from '@azure/msal-angular';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {TranslateUtils} from '../../../_shared/translate-utils';
import {firstValueFrom} from 'rxjs';

@Component({
    selector: 'app-energy',
    templateUrl: './energy.component.html',
    styleUrls: ['./energy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EnergyComponent implements OnInit {

    @Input() isExploitant = false;

    CockpitView = CockpitView;

    crtLang = TranslateUtils.defaultLanguage;
    appRoles = AppRoles;

    service: ServiceDto;
    customerId: string | null;
    serviceId: string;

    // cockpit
    cockpitView: CockpitView;
    customerMeasuringPoints: SearchMeasuringPointResultDto[] = [];

  constructor(private readonly authService: MsalService,
              private readonly serviceService: ServiceService,
              private readonly measuringPointService: MeasuringPointService,
              private readonly translateService: TranslateService,
              private readonly router: Router,
              private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
      this.crtLang = this.translateService.currentLang;
      this.serviceId = this.route.snapshot.params['serviceId'];

      if (this.serviceId) {
          try {

              if (this.isExploitant) {
                  this.customerId = null;

              } else {
                  this.customerId = this.authService.instance.getActiveAccount()?.localAccountId ?? null;
              }

              this.serviceService.getService(this.serviceId).pipe().subscribe(s => {
                  this.service = s;
                  if (this.customerId) {
                      this.fetchMeasuringPoint().then( mp => this.customerMeasuringPoints = mp);
                  }

                  // Cockpit
                  if (this.service.serviceConfig.serviceType === ServiceType.Energy) {
                      if (this.isExploitant) {
                          this.cockpitView = CockpitView.State;

                      } else {
                          this.cockpitView = CockpitView.User;
                      }
                  }
              });

          } catch (e) {
              const status = (e as any).status;
              if (status === 404) {
                  void this.router.navigate(['/']);
              } else {
                  throw e;
              }
          }
      }
  }

    // region Cockpit
    changeCockpitView(view: CockpitView): void {
        this.cockpitView = view;
    }

    private async fetchMeasuringPoint(): Promise<SearchMeasuringPointResultDto[]> {
        if (this.service.serviceConfig.serviceType === ServiceType.Energy && this.customerId) {
            return firstValueFrom(this.measuringPointService.searchMeasuringPoints(
                new SearchMeasuringPointDto({
                        serviceId: this.serviceId, serviceUnassignedOnly: false, language: this.crtLang, customerId: this.customerId, includeMeasuringPointWithHistoricalAssignments: true
                    }
                )));
        }
        return [];
    }

}

enum CockpitView {
    State,
    Consumption,
    User
}
